export default __webpack_public_path__ + "static/media/CheckEnrichedCompany.0a4afa75.svg";